<template>
  <div>
    <v-form
      v-if="step === 1"
      ref="form"
    >
      <v-layout>
        <v-textarea
          :value="value"
          :rules="[$store.state.validationRules.required, validateTrackingNos]"
          autofocus
          label="請輸入運單號碼"
          hint="一行一個快遞單號"
          rows="2"
          auto-grow
          outline
          @input="$emit('input', $event.trim())"
        />

        <v-btn
          color="info"
          @click="handleConfirm"
        >
          確認
        </v-btn>
      </v-layout>
    </v-form>

    <div v-else>
      <div>已填寫<b class="blue--text mx-1">{{ tnosRelArr.length }}</b>個單號</div>
      <div class="my-2">
        {{ tnosRelArr.join(',') }}
      </div>
      <v-divider class="mb-4" />
    </div>
  </div>
</template>

<script>
import { shouldRestrictBatchTrackingNosToParentChild } from '@g/utils/projectUtils'

export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    step: {
      type: Number,
      default: 1
    }
  },
  computed: {
    tnosRelArr () {
      if (!this.value) return []
      return this.value.split('\n')
        .map(item => item.trim())
        .filter(item => item.length)
    }
  },
  methods: {
    trackingNoRule (val) {
      if (this.$store.state.jyWarehouses.find(item => item.mobile === val)) {
        return '這是倉庫電話，非包裹快遞單號，請確認正確的快遞單號並登記'
      }
      if (['0082940036096', '0956940156307'].includes(val)) {
        return '這是巧巧郎的收款銀行帳號，非包裹快遞單號，請確認正確的快遞單號並登記'
      }
      return true
    },
    validateTrackingNos (value) {
      if (!value) return true

      const trackingNoRule = this.$store.state.validationRules.trackingNo
      const lines = value.split('\n').map(item => item.trim()).filter(item => item.length)
      const shouldRestrictParentChild = shouldRestrictBatchTrackingNosToParentChild(
        this.$store.state.project,
        this.$store.state.edition
      )
      let trackingNoPrefix = ''

      for (let i = 0; i < lines.length; i++) {
        const line = lines[i]

        // 验证运单号格式
        const formatResult = trackingNoRule(line)
        if (formatResult !== true) {
          return `第 ${i + 1} 行：${formatResult}`
        }

        // 验证自定义规则
        const customResult = this.trackingNoRule(line)
        if (customResult !== true) {
          return `第 ${i + 1} 行：${customResult}`
        }

        if (!shouldRestrictParentChild) continue

        if (line.length <= 5) {
          return `第 ${i + 1} 行：批量登記僅支援子母單`
        }

        const currentPrefix = line.slice(0, -5)
        if (i === 0) {
          trackingNoPrefix = currentPrefix
          continue
        }

        if (currentPrefix !== trackingNoPrefix) {
          return `第 ${i + 1} 行：批量登記僅支援子母單`
        }
      }

      return true
    },
    handleConfirm () {
      if (this.$refs.form.validate()) {
        this.$emit('confirm')
      }
    }
  }
}
</script>
